import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { manifest } from '@fielded/forth-utils'
import { formatAddress } from './utils'
import {
  handleSaveManifestChangesToDB,
  loadManifest,
  handleToggleProductOnManifest,
  updateManifestItem,
  fetchJobs,
  upsertManifestItem,
  removeManifestItem,
  getPrevWeekBalance
} from './jobs-reducer'
import DataSheet from './DataSheet'

class ManifestContainer extends Component {
  componentWillMount () {
    const {
      stop,
      fetchJobs,
      manifests,
      manifestLines,
      loadManifest
    } = this.props
    if (!stop._id) {
      fetchJobs()
    } else if (manifests.length === 0) {
      loadManifest(stop._id, manifestLines)
    }
  }

  componentWillReceiveProps (nextProps) {
    const { loadManifest, manifestLines, manifests } = this.props

    if (nextProps.stop._id && Array.isArray(nextProps.manifestLines)) {
      if (
        manifests.length !== nextProps.manifests &&
        manifestLines.length !== nextProps.manifestLines.length
      ) {
        loadManifest(nextProps.stop._id, nextProps.manifestLines)
      }
    }
  }
  findProductInManifest (product) {
    const { manifests } = this.props
    return manifests.find(item => {
      if (!item.productId) {
        return (
          item.name.replace(/\s/, '').toLowerCase() ===
          product.name.replace(/\s/, '').toLowerCase()
        )
      }
      return item.productId === product._id
    })
  }

  /**
   * this is used to sort and get the most current price by date
   * @param {*} prices
   */
  getCurrentPrice (prices = []) {
    // sort prices by date in decreasing order of date
    prices.sort((price1, price2) => {
      if (price2.date > price1.date) {
        return 1
      }
      if (price2.date < price1.date) {
        return -1
      }

      return 0
    })

    return prices[0] || {} // just incase prices[0] is undefined
  }

  render () {
    const {
      stop,
      handleSaveChanges,
      products,
      manifests,
      updateManifestItem,
      removeManifestItem,
      upsertManifestItem,
      isManifestSaving,
      requestOngoing,
      successMsg,
      getPrevWeekBalance
    } = this.props

    if (products.length === 0 || !stop._id || requestOngoing) {
      return <div>Loading Manifest</div>
    }

    return (
      <DataSheet
        successMsg={successMsg}
        products={products}
        prevWeekBalance={getPrevWeekBalance(stop)}
        manifest={manifests}
        onUpdateManifestItem={(product, patch) =>
          updateManifestItem(stop._id, product, patch)
        }
        onSaveChanges={() => handleSaveChanges(stop)}
        removeManifestItem={(index) => removeManifestItem(stop._id, index)}
        upsertManifestItem={(product, index, additionalProps) => upsertManifestItem(stop._id, product, index, additionalProps)}
        stopName={formatAddress(stop.address)}
        isManifestSaving={isManifestSaving}
      />
    )
  }
}

const mapStateToProps = (
  {
    jobs: {
      jobs,
      manifests,
      isJobsRequestOngoing,
      isManifestSaving,
      requestOngoing,
      successMsg
    },
    products: { products }
  },
  { match: { params } }
) => {
  // TODO: move into a selector
  // TODO: store jobs by ID
  const initState = {
    stop: {},
    manifestLines: [],
    manifests: [],
    products
  }
  let manifestLines = []

  const jobStop = jobs.find(jobStop => jobStop.job._id === decodeURIComponent(params.jobId))

  if (!jobStop) {
    return initState
  }
  const stop = jobStop.stops.find(stop => stop._id === decodeURIComponent(params.stopId))
  if (!stop) {
    return initState
  }

  if (stop.note && stop.note !== '') {
    manifestLines = manifest.parse(stop.note)
  }

  return {
    stop,
    manifestLines,
    manifests: manifests[stop._id] || [],
    products,
    jobs,
    job: jobStop,
    isJobsRequestOngoing,
    isManifestSaving,
    requestOngoing,
    successMsg
  }
}

const mapDispatchToProps = {
  handleSaveChanges: handleSaveManifestChangesToDB,
  loadManifest,
  handleToggleProductOnManifest,
  removeManifestItem,
  upsertManifestItem,
  updateManifestItem,
  fetchJobs,
  getPrevWeekBalance
}

ManifestContainer.propTypes = {
  stop: PropTypes.shape({
    _id: PropTypes.string
  }).isRequired,
  manifestLines: PropTypes.array.isRequired,
  manifests: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      qty: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ).isRequired,
  products: PropTypes.array.isRequired,
  loadManifest: PropTypes.func.isRequired,
  handleToggleProductOnManifest: PropTypes.func.isRequired,
  updateManifestItem: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(ManifestContainer)



// WEBPACK FOOTER //
// ./src/jobs/ManifestContainer.js